import type { Organisation, Project } from '@/types/journey-products'
import type { ApiProduct } from '@/types/product'

export type ApiIdfJourneyTemplate = {
  deleted: boolean
  stroomUUID_UNIQUE: string
  stroomProducent: Organisation | null
  verzendAdres: Location | null
  bestemmingAdres: Location | null
  stroomIHM: Organisation | null
  createdDate: string
  stroomName: string
  stroomVervoerder: Organisation[] | null
  stroomVerwerker: Organisation | null
  project: Project | null
  status: string
  idfStroomType: number
  ritBeschikbaar: number
  internBeschikbaar: number
  internAsInt: number
  materialen: ApiProduct[] | null
  allowedToActivate: boolean
  active: boolean
  invisible: boolean
  extraOptions: Record<string, unknown> | null
  transportInstructies: string | null
  intern: boolean
  stroomUUID: string
}

export type ApiJourneyTemplate = {
  stroomName: string | null
  stroomProducent: { id: string | null } | null
  verzendAdres: { locatieUUID: string | null } | null
  stroomIHM: null | { id: string | null }
  stroomVerwerker: null | { id: string | null }
  bestemmingsAdres: null | { locatieUUID: string | null }
  transportInstructies: string | null
  extraOptions: Record<string, unknown> | null
  materialen: ApiProduct[]
  project: { projectUUID: string | null } | { id: string | null }
  stroomVervoerder: { id: string }[]
  intern: boolean
}

export function createApiJourneyTemplate(): ApiJourneyTemplate {
  return {
    stroomName: null,
    stroomProducent: { id: null },
    verzendAdres: { locatieUUID: null },
    stroomIHM: null,
    stroomVerwerker: null,
    bestemmingsAdres: null,
    transportInstructies: null,
    extraOptions: {},
    materialen: [],
    project: { projectUUID: null },
    stroomVervoerder: [],
    intern: false,
  }
}
